import { Text, FontIcon, MenuList, FlexWrapper } from '@intigral/shared';
import { MenuItem } from '@intigral/shared/components/MenuList';
import { __ } from '../../../translations';
import useLanguage from '../../../hooks/useLanguage';
import { useSeasonList } from '../hooks/useSeasonList';

export const SeasonList = ({ seasons, setEpisodes, setRuntimeLength, episodes }) => {
    const language = useLanguage();
    const { selectedSeason, defaultSeason, onSeasonChanged } = useSeasonList(seasons, setEpisodes, setRuntimeLength);

    return (
        <>
            <FlexWrapper flexDirection="row" gap="1x" itemCount={1} justifyContent="between">
                <MenuList
                    variant="text"
                    triggerTitle={
                        <FlexWrapper flexDirection="row" gap="1x">
                            <Text as="span" alignment="start" fontWeight="medium" size={{ default: '18', md: '28' }}>
                                {selectedSeason === null
                                    ? defaultSeason?.label?.[language]
                                    : selectedSeason?.label?.[language]}
                            </Text>
                            <FontIcon name="arrow" size="small" md="medium" rotate="left" />
                        </FlexWrapper>
                    }
                    align="start"
                    selectedItem={selectedSeason === null ? defaultSeason?.Id : selectedSeason?.Id}
                    onChange={onSeasonChanged}
                >
                    {seasons &&
                        seasons.length > 0 &&
                        seasons.map((season, index) => {
                            return (
                                <MenuItem
                                    key={index}
                                    onClick={() => onSeasonChanged(season)}
                                    {...(selectedSeason && selectedSeason?.Id == season.Id ? { selected: true } : {})}
                                >
                                    {season.label[language]}
                                </MenuItem>
                            );
                        })}
                </MenuList>
                <Text as="p" alignment="start" color="gray">
                    {episodes.length}{' '}
                    {episodes.length > 1 ? __('details_popup_season_episodes') : __('details_popup_season_episode')}
                </Text>
            </FlexWrapper>
        </>
    );
};
